import { SCHEMA_VERSIONS } from "../constants/schemaVersions";
import { assertString } from "../utils/assertions";
import { createUuid } from "../utils/id";
import { nowIso } from "../utils/timestamps";

export const createVoyage = ({
  id = createUuid(),
  organizationId,
  vesselId,
  voyageNumber,
  status = "active",
  currentTripId,
  createdAt = nowIso(),
  createdBy,
  startedAt = createdAt,
  completedAt,
  updatedAt = createdAt,
  updatedBy,
  revision = 1,
  schemaVersion = SCHEMA_VERSIONS.VOYAGE,
}) => {
  assertString(id, "voyage.id");
  assertString(organizationId, "voyage.organizationId");
  assertString(vesselId, "voyage.vesselId");
  assertString(voyageNumber, "voyage.voyageNumber");
  assertString(createdBy, "voyage.createdBy");
  assertString(updatedBy || createdBy, "voyage.updatedBy");

  return {
    id,
    organizationId,
    vesselId,
    voyageNumber,
    status,
    currentTripId,
    createdAt,
    createdBy,
    startedAt,
    completedAt,
    updatedAt,
    updatedBy: updatedBy || createdBy,
    revision,
    schemaVersion,
  };
};
